export default __webpack_public_path__ + "static/media/smile-regular.c4440c82.svg";